<template>
  <div class="personal">
    <div class="x-margin-b">
      <div class="personal-infobox" v-for="info in renderList" :key="info.title">
        <!-- 账户信息 -->
        <h4 class="info-item-title">{{ info.title }}</h4>
        <div class="info-row" v-for="row in info.rows" :key="row.label">
          <div class="info-col">{{ row.label }}</div>
          <div :class="['info-col', { 'red-txt': row.redTxt }]" :title="row.value">
            {{ row.value }}
          </div>
          <div class="info-col">
            <ux-button
              v-if="row.btn"
              :disabled="row.btn.disabled"
              type="primary"
              text
              @click="row.btn.click"
            >
              {{ row.btn.text }}
            </ux-button>

            <span v-if="row.tooltip" class="info-col-tooltip">
              {{ $t('HT.personal.text1') }}
              <ux-tooltip :content="row.tooltip.text" placement="right">
                <i class="iconfont ux_icon_about"></i>
              </ux-tooltip>
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 修改手机号 -->
    <change-phone
      v-if="modalData.changePhone.isShow"
      :username="userData.username"
      :phone="userData.phone"
      @update-info="getInfo"
      @close="modalData.changePhone.isShow = false"
    ></change-phone>

    <!-- 修改邮箱 -->
    <change-email
      v-if="modalData.changeEmail.isShow"
      :username="userData.username"
      @update-info="getInfo"
      @close="modalData.changeEmail.isShow = false"
    ></change-email>

    <!-- 绑定邮箱 -->
    <bind-email
      v-if="modalData.bindEmail.isShow"
      @update-info="getInfo"
      @close="modalData.bindEmail.isShow = false"
    ></bind-email>

    <!-- 修改密码 -->
    <change-password
      v-if="modalData.changePassword.isShow"
      :has-email="userData.bind_email"
      :phone="userData.phone"
      @update-info="getInfo"
      @show-bind-email="showBindEmail"
      @close="modalData.changePassword.isShow = false"
    ></change-password>
  </div>
</template>

<script>
import changeUsername from './template/changeUsername';
import showGroup from './template/showGroup';
import changePhone from './modal/changePhone';
import changeEmail from './modal/changeEmail';
import changePassword from './modal/changePassword';
import bindEmail from './modal/bindEmail';

export default {
  components: {
    bindEmail,
    changeUsername,
    showGroup,
    changePhone,
    changeEmail,
    changePassword
  },
  data() {
    return {
      userData: {},
      group_list: [], //用户组里的用户名
      id: this.$store.state.login.userData.id, // id
      ownerData: {}, //用户信息
      modalData: {
        // 修改手机
        changePhone: {
          isShow: false
        },
        // 修改邮箱
        changeEmail: {
          isShow: false
        },
        // 绑定邮箱
        bindEmail: {
          isShow: false
        },
        // 修改密码
        changePassword: {
          isShow: false
        }
      }
    };
  },
  mounted() {
    this.ownerData = this.$store.state.login.userData;
  },
  created() {
    this.getInfo();
  },
  computed: {
    // 渲染列表
    renderList() {
      const { username, owner, phone, email, bind_email, bind_pass } = this.userData;
      const renderList = [
        {
          title: this.$t('HT.personal.text2'),
          rows: [
            {
              label: this.$t('HT.changeEmail.username'),
              value: username,
              btn: {
                text: this.$t('HT.edit'),
                click: () => {
                  this.showUsername();
                }
              }
            },
            {
              label: this.$t('HT.personal.text3'),
              value: owner ? this.$t('HT.personal.text4') : this.$t('HT.personal.text5'),
              tooltip: {
                text: this.$t('HT.personal.text6')
              }
            }
          ]
        },
        {
          title: this.$t('HT.personal.text7'),
          rows: [
            {
              label: this.$t('HT.personal.text8'),
              value: this.$t('HT.personal.text9')
            }
          ]
        },
        {
          title: this.$t('HT.personal.text10'),
          rows: [
            {
              label: this.$t('HT.personal.phone'),
              value: phone,
              btn: {
                text: this.$t('HT.personal.changePhone'),
                click: () => {
                  this.showTelphone();
                }
              }
            },
            {
              label: this.$t('HT.addUser.email'),
              value: bind_email ? email : this.$t('HT.personal.text11'),
              redTxt: !bind_email,
              btn: {
                text: `${bind_email ? this.$t('HT.changePsw.change') : this.$t('HT.bind')}${this.$t(
                  'HT.addUser.email'
                )}`,
                click: () => {
                  if (bind_email) {
                    this.showChangeEmail();
                  } else {
                    this.showBindEmail();
                  }
                }
              }
            },
            {
              label: this.$t('HT.addUser.psw'),
              value: bind_pass ? '******' : this.$t('HT.personal.nodate'),
              redTxt: !bind_pass,
              btn: {
                text: `${
                  bind_pass ? this.$t('HT.changePsw.change') : this.$t('HT.personal.text12')
                }${this.$t('HT.addUser.psw')}`,
                click: () => {
                  this.showChangePassword();
                }
              }
            }
          ]
        }
      ];
      return renderList;
    }
  },
  methods: {
    /**
     * 获取账号信息
     */
    getInfo() {
      this.$uxLoading.show();
      this.$api.user.getInfo().then((res) => {
        if (res.code == 10000) {
          this.userData = res.data;
          const list = [];
          for (let item of res.data.group_list) {
            list.push(item.group_name);
          }
          // 保存所有用户组下面的用户名
          this.group_list = list;
        }
      });
    },

    // 修改账号名称弹窗
    showUsername() {
      const title = this.$t('HT.personal.changeAccount');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(changeUsername);
        },
        confirm: (val) => {
          this.$uxLoading.show();
          this.$api.user.username({ username: val.username }).then((res) => {
            if (res.code == 10000) {
              this.$uxModal.hide();
              this.$uxMessage.success(this.$t('HT.addApi.editSuccess2'));
              this.getInfo();
              // 修改vuex的数据
              const vuexUserData = JSON.parse(JSON.stringify(this.$store?.state?.login?.userData));
              vuexUserData.username = val.username;
              this.$store.commit('saveUserData', vuexUserData); // 保存登录者信息
            }
          });
        }
      });
    },

    // 修改手机号码弹窗
    showTelphone() {
      this.modalData.changePhone.isShow = true;
    },
    // 修改弹窗
    showChangeEmail() {
      this.modalData.changeEmail.isShow = true;
    },
    // 绑定邮箱
    showBindEmail() {
      this.modalData.bindEmail.isShow = true;
    },

    // 修改密码
    showChangePassword() {
      this.modalData.changePassword.isShow = true;
    },

    /**
     * 绑定邮箱弹框
     */
    // showBing() {
    //     this.$uxModal.show({
    //         title: '绑定邮箱',
    //         content: (h) => {
    //             return h(bindEmail, {
    //                 props: {},
    //             });
    //         },
    //         confirm: (val) => {
    //             this.$api.user.email(val).then(res => {
    //                 if (res.code == 10000) {
    //                     this.$uxModal.hide();
    //                     // this.$set(this.userData, 'email', params.email);
    //                     this.$uxMessage.success('绑定成功');
    //                     this.getInfo();
    //                 }
    //             });
    //         }
    //     });
    // },
    /**
     * 修改密码
     */
    gotoEditPsw() {
      this.$router.push('/editPsw');
    }

    // // 修改用户分组弹窗
    // showGroup() {
    //     this.$uxModal.show({
    //         title: '修改用户组',
    //         content: (h) => {
    //             return h(showGroup);
    //         },
    //         confirm: (val) => {
    //             const joinGroupArr = Array.of(val.group_ids);
    //             this.changeGroup(joinGroupArr);
    //         }
    //     });
    // },

    // // 修改用户分组
    // changeGroup(val) {
    //     this.$api.system.changeGroupInfo(this.id, { group_ids: val }).then(res => {
    //         if (res.code == 10000) {
    //             this.$uxModal.hide();
    //             this.$uxMessage.success('修改成功');
    //             this.getInfo(this.id);
    //         }
    //     });
    // },

    /**
     * 修改登录密码
     * @param {Object} val 新密码旧密码
     */
    // editPass(val) {
    //     this.$uxLoading.show();
    //     let postData = {
    //         new_pwd: val.password,
    //         old_pwd: val.oldPassword
    //     };
    //     // let id = this.$store.state.login.userData.id;
    //     this.$api.user.password(postData).then(res => {
    //         if (res.code == 10000) {
    //             this.$uxModal.hide();
    //             this.$uxMessage.success('修改成功');
    //             this.getInfo();
    //         }
    //     });
    // },
  }
};
</script>

<style lang="scss" scoped>
.personal {
  .personal-infobox {
    padding: 32px 40px 24px;
    margin-bottom: 20px;
    border-radius: 8px;
    background: #fff;
  }

  .info-item-title {
    height: 64px;
    font-size: 18px;
    font-weight: 600;
    color: $color-title;
    line-height: 24px;
  }

  .info-row {
    width: 100%;
    display: flex;
    align-items: center;
    height: 20px;
    margin-bottom: 24px;
    line-height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: $color-text;

    .info-col {
      box-sizing: border-box;
      margin-right: 20px;
      width: 190px;
      overflow: hidden;
      text-overflow: ellipsis;

      &.red-txt {
        color: $color-error;
      }
    }

    .info-col-tooltip {
      font-size: 14px;
      font-weight: 400;
      color: $color-text-disable;

      .ux-tooltip {
        cursor: pointer;
        color: $color-text-secondary;
      }
    }
  }
}
</style>
